<template>
<main class="content-body">
  <header class="page-header">
    <h2>Zone A</h2>
  </header>
  <div class="row">
    <div class="col-md-12 col-lg-12 col-xl-12">
      <section class="panel">
        <header class="panel-heading">
          <h2 class="panel-title" style="display:inline">Dossiers</h2>
        </header>
        
        <div class="panel-body">
          <div class="row">
            <div class="col-xl-12 mb-md">
              <label  style="float:left;margin-right:10px;">
                <input style='min-width: 150px; width:250px;display:inline;' v-bind:value="keywords" v-on:input="debounceSearch($event.target.value)" class="form-control" placeholder="Recherche" aria-controls="listing-datatable">
              </label>

              <label style="float:left;margin-right:10px;">
                <select v-model="agency_status_id" v-on:change="newStart" class="form-control" style='max-width:150px'>
                  <option disabled value="">Désignation</option>
                  <option value="">Tous</option>
                  <option v-for="option in agency_status_option"
                    :value="option.status_id" :key="option.status_id">
                    {{ option.status_name }}
                  </option>
                </select>
              </label>

              <label style="float:left;margin-right:10px;">
                <select v-model="dossier_type_key" v-on:change="newStart" class="form-control" style='max-width:150px'>
                  <option disabled value="">Type du dossier</option>
                  <option value="">Tous</option>
                  <option v-for="option in dossier_type_option"
                    :value="option.key" :key="option.key">
                    {{ option.name }}
                  </option>
                </select>
              </label>

              <label style="float:left;margin-right:10px;">
                <select v-model="dossier_status_key" v-on:change="newStart" class="form-control" style='max-width:150px'>
                  <option disabled value="">Dernière étape</option>
                  <option value="">Tous</option>
                  <option v-for="option in dossier_status_option"
                    :value="option.key" :key="option.key">
                    {{ option.name }}
                  </option>
                </select>
              </label>

              <label style="float:left;margin-right:10px;">
                <select v-model="dossier_appreciation_key" v-on:change="newStart" class="form-control" style='max-width:150px'>
                  <option disabled value="">Appréciation</option>
                  <option value="">Tous</option>
                  <option v-for="option in dossier_appreciation_option"
                    :value="option.key" :key="option.key">
                    {{ option.name }}
                  </option>
                </select>
              </label>

              <label style="float:left;margin-right:10px;">
                <select v-model="responsable" v-on:change="newStart" class="form-control" style='max-width:150px'>
                  <option disabled value="">Responsable</option>
                  <option value="">Tous</option>
                  <option v-for="option in responsable_option"
                    :value="option.user_id" :key="option.user_id">
                    {{ option.responsable_name }}
                  </option>
                </select>
              </label>
              
              <div class="form-check d-inline-block" style="padding-top: 0.3em; padding-left: 0.2em;">
                <label class="form-checkbox-input" style="cursor: pointer;">
                  <input class="form-check-input" type="checkbox" v-model="include_archived" @change="newStart">
                  Inclure les archivés
                </label>
              </div>
            </div>
          </div>
        </div>
                      
        <div class="panel-body">
          <div v-show="dossiers.length > 0">
            
            <div class="row">
              <div class="col-md-12 col-lg-12 col-xl-12 text-right">
                <Pagination
                :pageSize.sync="pageSize"
                :sizeOptions="sizeOptions"
                :selectedPageNum="pageNum"
                :totalRecords="totalRecords"
                v-on:change-page="changePage"
                :limit="2"
                :isLoading="isLoading"
                :disable="isLoading"
                >
                </Pagination>
              </div>
            </div>
            
            <div class="table-responsive">
              <div class="table-responsive">
                <GridGeneral
                :data="dossiers"
                :columns="gridColumns"
                :sortColumns="gridColumnsSort"
                :loadData="refresh">
                </GridGeneral>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-12 col-lg-12 col-xl-12 text-right">
                <Pagination
                :pageSize.sync="pageSize"
                :sizeOptions="sizeOptions"
                :selectedPageNum="pageNum"
                :totalRecords="totalRecords"
                v-on:change-page="changePage"
                :limit="2"
                :isLoading="isLoading"
                :disable="isLoading"
                >
                </Pagination>
              </div>
            </div>
          </div>
          
          <div class="text-center" v-if="dossiers.length === 0">
            <em>Aucun dossier n'a été trouvé.</em>
          </div>
        </div>
      </section>
    </div>
  </div>
</main>
</template>
<script>

import axios from 'axios';
import GridGeneral from '@/components/GridGeneral.vue'
import Pagination from '@/components/Pagination.vue'

function scrollToTop(){
  window.setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, 200);
}

export default {
  data: function() {return {
    keywords:'',
    dossiers: [],
    sort:'last_updated_at',
    sortOrder:0,
    responsable: '',
    service_provider_id: '',
    agency_status_id: '',
    dossier_type_key: '',
    dossier_status_key: '',
    dossier_appreciation_key: '',
    include_archived: false,
    responsable_option: [],
    service_provider_option: [],
    agency_status_option: [],
    dossier_type_option: [],
    dossier_status_option: [],
    dossier_appreciation_option: [],
    gridColumns: [
      {field:'designation_dossier_id',title:'Clé'},
      {field:'service_provider',title:'Fournisseur'},
      {field:'agency_status',title:'Désignation'},
      {field:'name',title:'Dossier'},
      {field:'type',title:'Type du Dossier'},
      {field:'latest_designation_status',title:'Dernière étape'},
      {field:'last_updated_at',title:'Depuis'},
      {field:'dossier_appreciation',title:'Appréciation'},
      {field:'responsable',title:'Reponsable'}
    ],
    gridColumnsSort: ['designation_dossier_id', 'name', 'type', 'last_updated_at', 'service_provider', 'agency_status', 'responsable'],
    pageSize: 50,
    sizeOptions: [20, 50, 100],
    pageNum: 1,
    totalRecords: 0,
    isLoading: false
  }},
  name: 'DossierList',
  components: {
    GridGeneral,
    Pagination
  },
  watch: {
    $route() {
      this.refresh();
      this.loadFilters();
    },
    pageNum(newVal, oldVal) {
      if (+newVal !== +oldVal) {
        this.refresh();
        replaceUrlHash(this.prepareUrlHashToSet())
      }
    },
    pageSize(newVal, oldVal) {
      if (+newVal !== +oldVal) {
        this.refresh();
        replaceUrlHash(this.prepareUrlHashToSet())
      }
    }
  },
  methods: {
    debounceSearch: function(val){
      this.keywords = val;
      if(this.search_timeout) clearTimeout(this.search_timeout);
      
      const self = this;
      this.search_timeout = setTimeout(function() {
        self.refresh();
      }, 200);
    },
    
    loadFilters: function() {
      axios
        .get(this.$root.$data.server_base + '/api/dossier_filter_dropdown.php',
          { })
        .then(response => {
          this.responsable_option = response.data.responsable;
          this.service_provider_option = response.data.service_provider;
          this.agency_status_option = response.data.agency_status.filter((entry) => {
            return entry.status_name != "Non-identifié"
          }).map((entry) => {
            entry.status_name = reLabelAgencyStatus(entry.status_name)
            return entry
          });
          this.dossier_type_option = response.data.dossier_type;
          this.dossier_status_option = response.data.dossier_status.filter((entry) => {
            if (entry.key == "dh_suivi") return false;
            if (this.include_archived) return true;
            return entry.key != "dh_archive"
          });
          this.dossier_appreciation_option = response.data.dossier_appreciation;
        })
    },
    
    changePage: function(pageNum)
    {
      this.pageNum = pageNum
    },

    prepareUrlHashToSet: function() {
      return `page=${this.pageNum}&pageSize=${this.pageSize}`
    },

    readPaginationFromUrlHashAndRefresh: function() {
      this.preventRefresh = true;
      this.$nextTick(() => {
        this.setSelectedPageNumFromUrlHash()
        this.setSelectedPageSizeFromUrlHash()
        this.preventRefresh = false;
        this.refresh();
      })
    },

    setSelectedPageNumFromUrlHash: function() {
      var pageNumFromUrlHash = getHashParameterByName('page')
      if (!pageNumFromUrlHash || pageNumFromUrlHash === '') {
        return
      }
      this.pageNum = pageNumFromUrlHash
    },

    setSelectedPageSizeFromUrlHash: function() {
      var pageSizeFromUrlHash = getHashParameterByName('pageSize')
      if (!pageSizeFromUrlHash || pageSizeFromUrlHash === '') {
        return
      }
      this.pageSize = pageSizeFromUrlHash
    },
        
    refresh: function() {
      if (this.preventRefresh === true) return
      this.isLoading = true
      axios
        .get(this.$root.$data.server_base + '/api/dossiers.php',
          { params: {
            keywords: this.keywords,
            sort: this.sort,
            sortOrder: this.sortOrder,
            responsable: this.responsable,
            service_provider_id: this.service_provider_id,
            agency_status_id: this.agency_status_id,
            dossier_type_key: this.dossier_type_key,
            dossier_status_key: this.dossier_status_key,
            dossier_appreciation_key: this.dossier_appreciation_key,
            include_archived: this.include_archived,
            page:this.pageNum,
            page_size:this.pageSize
          }})
        .then(response => {
          this.$checkApiErrors(response.data);
          this.dossiers = this.supplementDossiers(response.data.dossiers);
          this.pageNum = response.data.page_num;
          this.totalRecords = response.data.total;
          this.isLoading = false
        })
    },
    
    newStart: function () {
      if (this.include_archived == false && this.dossier_status_key == 'dh_archive') {
        this.dossier_status_key = ''
      }
      this.refresh();
      this.loadFilters();
    },

    supplementDossiers(dossiers) {
      return dossiers.map((d) => {
        d.agency_status = reLabelAgencyStatus(d.agency_status)
        d.service_provider = `<div class="text-nowrap" style="overflow: hidden; text-overflow: ellipsis; max-width: 14em;">${d.service_provider}</div>`
        d.last_updated_at = `<span class="text-nowrap" title="${this.moment(d.last_updated_at).format('lll')}">${this.moment(d.last_updated_at).fromNow()}</span>`
        d.latest_designation_status = reLabelLatestDesignationStatus(d.latest_designation_status)
        return d
      })
    }
  },
  mounted() {
    this.readPaginationFromUrlHashAndRefresh();
    this.refresh()
    this.loadFilters()
  }
}

function replaceUrlHash(newHash) {
  if ((''+newHash).charAt(0) !== '#') newHash = '#' + newHash;
  history.replaceState('', '', newHash);
}

// https://stackoverflow.com/a/901144/2414273
function getHashParameterByName(name, hash) {
  if (!hash) hash = window.location.hash;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[#&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(hash);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function reLabelAgencyStatus(status) {
  switch(status) {
    case 'Désigné complet': return 'Complet';
    case 'Désigné partiel': return 'Partiel';
  }
  return status;
}

function reLabelLatestDesignationStatus(status) {
  if (status === 'obtention de désignation') {
    return '<span style="color: #00ab03">✔</span> ' + capitalize(status)
  }
  if (status === null) { return status }
  return capitalize(status)
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

</script>
